var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDominantSpeaker = function SvgDominantSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10c1.109 0 2 .891 2 2s-.891 2-2 2v6c0 1.094-.906 2-2 2-2.781-2.312-7.266-5.484-12.688-5.938-1.859.625-2.5 2.797-1.281 4.047-1.094 1.797.313 3.063 1.969 4.359-.969 1.906-5 1.937-6.438.609-.906-2.781-2.25-5.563-1.156-9.078H2.5a2.507 2.507 0 01-2.5-2.5v-3c0-1.375 1.125-2.5 2.5-2.5H10c6 0 11-3.5 14-6 1.094 0 2 .906 2 2v6zm-2 9.437V4.531c-4.078 3.125-8.031 4.922-12 5.359v4.219c3.969.438 7.922 2.203 12 5.328z"
  })));
};

export default SvgDominantSpeaker;